// i18n area 'system' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.et-EE.meta.json.
import type { enUS } from './system'

export const etEE: typeof enUS = {
  diagnostics: {
    title: 'Diagnostika',
    subtitle: 'Mis on valesti, halvim enne — sama lääts mis tvirt diagnose',
    reload: 'Laadi uuesti',
    loadError: 'Diagnoosi ei õnnestunud lugeda',
    exportBundle: 'Ekspordi pakett',
    exportError: 'Paketti ei õnnestunud luua',
    noProblem: 'Kontrollitud aladel probleeme pole',
    nothingInspected: 'MIDAGI ei kontrollitud — see ei ole tervisetõend',
    inspected: 'Kontrollitud',
    notInspected: 'EI kontrollitud',
    localHint: 'Sõlme kohalikke alasid (systemd-üksused, journal) loetakse ainult CLI-st: tvirt diagnose --area local — tee siis, kui API ei vasta.',
    thresholds: 'ebaõnnestunud ülesanded {hours} h jooksul, heartbeat hilinenud üle {seconds} s',
    severity: {
      critical: 'Kriitiline',
      warning: 'Hoiatus',
      unknown: 'Teadmata'
    }
  },
  explorer: {
    title: 'Sirvi ressursse',
    root: 'Juur',
    empty: "Selles scope'is ei ole ühtegi ressurssi",
    previewHint: 'Vali objekt, et näha selle eelvaadet',
    open: 'Ava',

    // CRUD-loendite deep-link ?scope= (voor #109), sirvijast (#143).
    openScoped: "Ava loend selles scope'is",
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-template',
      ct: 'CT',
      ctTemplate: 'CT-template',
      app: 'Rakendus',
      overlayNetwork: 'Overlay-võrk',
      networkService: 'Võrguteenus',
      fabric: 'Fabric',
      subnet: 'Alamvõrk',
      storage: 'Salvestuskogum',
      disk: 'Ketas',
      catalogFile: 'Kataloogifail',
      ociRegistry: 'OCI-registry',
      ociImage: 'OCI-tõmmis',
      cephCluster: 'Ceph-klaster',
      backupDestination: 'Varunduse sihtkoht',
      user: 'Kasutaja',
      group: 'Grupp',
      role: 'Roll',
      credential: 'Mandaat',
      tag: 'Silt',
      proximityRule: 'Proximity reegel'
    }
  },
  tags: {
    title: 'Sildid',
    empty: 'Ühtegi silti ei ole',
    add: 'Lisa silt',
    remove: 'Eemalda',
    name: 'Silt',
    value: 'Väärtus',
    save: 'Salvesta',
    saveError: 'Siltide salvestamine ebaõnnestus',
    loadError: 'Siltide sõnavara laadimine ebaõnnestus',
    noVocabulary: 'Selle ressursitüübi jaoks ei ole ühtegi silti saadaval',

    // Juba määratud üheväärtuseline silt vastab 409-ga: asendus on alati
    // selgesõnaline — mitte kunagi vaikimisi väljavahetamine (disain,
    // ratifitseeritud 2026-07-27).
    overwrite: 'Asenda praegune väärtus',

    // Süsteem > Sildid, sõnavara pind.
    createTitle: 'Loo silt',
    editTitle: 'Muuda silti',
    nameHint: 'Tähed, numbrid, punktid, sidekriipsud ja alakriipsud — ilma märkideta ":" ja "/"; prefiks tvirt- on platvormile reserveeritud',
    cardinality: 'Kardinaalsus',
    cardinalitySingle: 'Üksainus väärtus',
    cardinalityMultiple: 'Mitu väärtust',
    cardinalityHint: 'Üheainsa väärtuse korral küsib sildi uuesti omistamine selle asendamist',
    autoCreate: 'Väärtuste automaatne loomine',
    autoCreateOn: 'Omistamisel',
    autoCreateOff: 'Ainult deklareeritud',
    autoCreateHint: 'Sees: uue väärtuse omistamine loob selle. Väljas: omistada saab ainult deklareeritud väärtusi',
    values: 'Väärtused',
    noValues: 'Ühtegi väärtust ei ole deklareeritud',
    addValue: 'Lisa väärtus',
    duplicateValue: 'Dubleeriv väärtus',
    kinds: 'Ressursitüübid',
    kindsAll: 'Kõik',
    kindsPlaceholder: 'Kõik',
    kindsHint: 'Jäta tühjaks, et lubada iga sildistatav ressursitüüp',
    systemChip: 'Süsteem',
    deleteCascade: 'Eemalda ka omistused',
    deleteCascadeHint: 'Silt, mis on veel mõnele ressursile omistatud, lükatakse tagasi: selle valikuga kaovad väärtused ja kõik omistused koos sildiga.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Loo scope',
    editTitle: 'Nimeta scope ümber',
    path: 'Teekond',
    segment: 'Segment',
    segmentHint: 'Väiketähed, numbrid ja sidekriipsud (DNS-1123)',
    parent: 'Ülem',
    rootChip: 'Juur',
    preview: 'Uus scope',
    pickLabel: 'Scope',
    pickHint: 'Kus objekt klastri puus elab — juures või mõnes selle sees olevas vDC-s.',
    ociCache: 'OCI vahemälu (ülekirjutus)',
    appEphemeral: 'Rakenduste ajutine kogum (ülekirjutus)',
    inherit: 'Pärib',
    inheritsFrom: 'Pärib kohalt',
    inheritsCluster: 'Pärib klastri vaikeväärtuse',
    inheritsNone: 'Pärib — tegelikku kogumit ei ole',
    failoverProtection: 'Kaitse halvenenud klastris',
    networkWeight: 'Võrgu kaal',
    networkCeil: 'Võrgu ülempiir (Mbps)',
    protectionProtected: 'Kaitstud',
    protectionExpendable: 'Ohverdatav halvenemisel',
    protectionDefault: 'Klastri vaikeväärtus'
  },

  // Süsteem > Teave (voor #124, 2026-07-31): platvormi versioonid pargis
  // (kõige rohkem kaks uuenduse keskel), komponendid sõlmede kaupa, kohapeal
  // serveeritav PDF-käsiraamat ja sisse sulatatud litsentsikaart.
  sysinfo: {
    summary: 'Platvormi versioonid klastris, iga sõlme komponendid, haldusjuhend ja litsents.',
    platformTitle: 'TVirti platvorm',
    platformSubtitle: 'Klastri sõlmedes vaadeldud versioonid',
    versionOnNodes: '{version} {n} sõlmes',
    versionOnOneNode: '{version} 1 sõlmes',
    mixedVersions: 'Klastris on rohkem kui üks platvormi versioon — see on ootuspärane ainult käimasoleva uuenduse ajal (kõige rohkem kaks).',
    tooManyVersions: 'Klastris on rohkem kui kaks platvormi versiooni — see ei ole kunagi ootuspärane, isegi mitte uuendamise ajal: kontrolli allolevaid sõlmi.',
    unreportedNodes: 'Versiooniraportit ei ole veel saatnud: {nodes}',
    noVersionsYet: 'Ükski sõlm ei ole veel oma versioone raporteerinud.',
    nodesUnavailable: 'Sõlmede loend ei ole sinu õigustega nähtav — platvormi versioone ei saa kuvada.',
    colNode: 'Sõlm',
    manualTitle: 'Haldusjuhend',
    manualSubtitle: 'Kohalik koopia, mida serveerib see klaster',
    manualBody: 'Täielik TVirti kasutusjuhend PDF-ina, serveeritud otse platvormilt — saadaval ka air-gapped keskkondades.',
    manualLink: 'Haldusjuhend (PDF)',
    apiExplorerTitle: 'API sirvija',
    apiExplorerSubtitle: 'OpenAPI leping, sirvitav',
    apiExplorerBody: 'Platvormi täielik OpenAPI leping — iga marsruut, skeem ja vastusekood — sirvitav brauserist, serveeritud selle sõlme kaudu.',
    apiExplorerLink: 'Uuri API-t',
    kubeTitle: 'Kubernetesi ühilduvus',
    kubeSubtitle: 'kubectl ja selle tööriistad natiivse API ees',
    kubeBody: 'TVirt KubeCompat projitseerib Podid, Deploymentid, Service’id, nimeruumid, sõlmed ja sündmused Kubernetese dialekti — ainult lugemiseks, lisaks Deploymentide kustutamine. Iga väljakutse läbib natiivse API sinu õigustega: kasuta kubeconfigis app tokenit bearerina.',
    kubeEndpoint: 'Endpoint kubectl-i jaoks',
    kubeStatusActive: 'Aktiivne — Kubernetes {version}',
    kubeStatusMissing: 'Sellesse sõlme pole paigaldatud (pakett trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Paigaldatud, kuid ei vasta — kontrolli üksust trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Kontrollimine…'
  },

  // Litsentsimine (voor 2026-07-29): sõltumise alusel käiva litsentsi leht.
  licensing: {
    title: 'Klastri litsents',
    subtitle: 'Sõltumuslitsents — kõige rohkem üks klastri kohta',
    absentTitle: 'Ühtegi litsentsi ei ole registreeritud',
    absentBody:
      'Ilma kehtiva litsentsita keeldub klaster uusi virtuaalmasinaid käivitamast (töötavad VM-id jäävad tööle). Registreeri tootevõti, mille said koos tellimusega.',
    registerButton: 'Registreeri litsents',
    removeButton: 'Eemalda litsents',
    state: {
      ok: 'Kehtiv',
      limitExceeded: 'Piir ületatud',
      expired: 'Aegunud'
    },
    productKeyLabel: 'Tootevõti',
    basisLabel: 'Piirangu alus',
    basis: {
      concurrentVms: 'Samaaegselt töötavad VM-id',
      physicalCores: 'Füüsilised tuumad (klaster kokku)'
    },
    limitLabel: 'Piir',
    usageLabel: 'Praegune kasutus',
    usageOf: '{used} / {limit}',
    usagePartial: 'osaline summa — {n} sõlmel puudub vaadeldud CPU topoloogia',
    usageUnknown: 'praegu ei ole vaadeldav',
    expiresLabel: 'Aegumine',
    neverExpires: 'mitte kunagi',
    registeredLabel: 'Registreeritud',
    gateNote:
      'Kui litsents puudub, on aegunud või piir on ületatud, keeldub klaster UUSI virtuaalmasinaid käivitamast. Töötavad VM-id jäävad tööle ja HA taaskäivitused sellest ei kannata.',
    devStage:
      'Arendusfaas: tootevõti võetakse vastu sellisena, nagu ta on, koos siin deklareeritud piirangutega; allkirjastatud võtmega valideerimine jõuab kohale mõne tulevase väljalaskega.',
    dialogTitle: 'Registreeri litsents',
    dialogExpiresHelp: 'Tühi = litsents ei aegu kunagi',
    dialogSubmit: 'Registreeri',
    dialogError: 'Litsentsi registreerimine ebaõnnestus.',
    removeTitle: 'Eemalda litsents',
    removeBody:
      'Klaster jääb ILMA LITSENTSITA: uued virtuaalmasinad keelduvad käivitumast, kuni sa uue litsentsi registreerid. Töötavad VM-id jäävad tööle.',
    removeConfirm: 'Eemalda',
    removeError: 'Litsentsi eemaldamine ebaõnnestus.'
  },
  rbac: {
    tabRoles: 'Rollid',
    tabGrants: 'Delegeeringud',
    rolesTitle: 'Rollid',
    createRoleTitle: 'Loo roll',
    editRoleTitle: 'Muuda rolli',
    nameHint: 'Väiketähed, numbrid ja sidekriipsud; prefiks tvirt- on reserveeritud',
    systemChip: 'Süsteem',
    permissions: 'Õigused',
    permissionsPlaceholder: 'Lisa õigus…',
    includedRoles: 'Kaasatud rollid',
    includedRolesPlaceholder: 'Lisa roll…',
    grantsTitle: 'Delegeeringud',
    createGrantTitle: 'Loo delegeering',
    principal: 'Principal',
    principalKind: 'Principali tüüp',
    principalUser: 'Kasutaja',
    principalGroup: 'Grupp',
    role: 'Roll',
    grantRight: 'Delegeerimine',
    grantRightChip: 'Võib edasi delegeerida',
    grantRightLabel: 'Koos delegeerimisõigusega (saaja võib seda rolli omakorda edasi delegeerida)',
    effective: 'Kehtiv',
    notEffective: 'Ei kehti',
    createdAt: 'Loodud',
    scopeHint: 'täpne /path, rekursiivne /path/* — delegeeringud kinnituvad haagitud juure külge (/* ei ole delegeeritav)'
  },
  groups: {
    title: 'Grupid',
    createTitle: 'Loo grupp',
    nameHint: "Väiketähed, numbrid ja sidekriipsud; unikaalne oma scope'is",
    members: 'Liikmed',
    membersTitle: 'Liikmed',
    membersPlaceholder: 'Lisa kasutaja…',
    noMembers: 'Ühtegi liiget ei ole',
    realmMappings: 'Realmi vastendused',
    realmMappingsTitle: 'Realmi vastendused',
    realmMappingsHint:
      'Millele see grupp igas välises realmis vastab. Kuuluvus loetakse kataloogist sisselogimise hetkel: kataloogi gruppi, mida keegi siin ei vastenda, eiratakse, ja pesastust ei lahendata — see tuleb kataloogi poolel lamedaks teha.',
    realm: 'Realm',
    externalGroup: 'Väline grupp',
    addRealmMapping: 'Lisa vastendus',
    removeRealmMapping: 'Eemalda vastendus',
    noRealmMappings: 'Ühtegi realmi vastendust ei ole',

    // Jaotisteks liigendatud loomisdialoog (realm-wizardi voor, 2026-08-03):
    // Üldine pluss väliste realmidega vastendamise pind koos kõneka tühja
    // olekuga.
    sectionGeneral: 'Üldine',
    mappingsNoRealms: 'Ühtegi välist realmi ei ole seadistatud — vastendamise pind avaneb kohe, kui mõni realm olemas on.',
    mappingsNoRealmsLink: 'Ava sakk Realmid ja SSO',

    // Grupi pandud MFA kohustus (voor #178, pool B): puhas OR — grupp saab
    // kohustuse ainult LISADA, mitte kunagi seda maha võtta.
    mfaRequired: 'MFA kohustus',
    mfaRequiredChip: 'Nõuab MFA-d',
    mfaNotRequiredChip: 'Kohustust ei ole',
    mfaRequiredHint:
      'Puhas OR: grupp saab teise faktori kohustuse oma liikmetele LISADA — ka välistele identiteetidele, realmi vastenduste kaudu —, kuid mitte kunagi seda maha võtta. Kehtib alates järgmisest sisselogimisest: avatud seansse ei suleta.'
  },
  users: {
    title: 'Kasutajad',
    createTitle: 'Loo kasutaja',
    editTitle: 'Muuda kasutajat',
    username: 'Kasutajanimi',
    usernameHint: 'Väiketähed, numbrid, punktid ja sidekriipsud',
    displayName: 'Kuvatav nimi',
    enabled: 'Lubatud',
    state: 'Olek',
    enabledChip: 'Lubatud',
    disabledChip: 'Keelatud',
    lockedChip: 'Lukustatud',
    password: 'Parool',
    passwordSetChip: 'Määratud',
    mustChangeChip: 'Tuleb vahetada',
    initialPassword: 'Algne parool',
    initialPasswordHint: 'Kasutaja peab selle esimesel sisselogimisel vahetama',
    lastLogin: 'Viimane sisselogimine',
    neverLoggedIn: 'Pole kunagi sisse loginud',
    setPasswordTitle: 'Määra parool',
    setPasswordHint: 'Administratiivne asendus — nõuab sinu parooli (sudo-režiim) ja kohustab kasutajat seda järgmisel sisselogimisel vahetama.',
    operatorPassword: 'Sinu parool',
    unlock: 'Ava konto lukust',
    revokeTitle: 'Tühista seansid',
    revokeBody: 'Kõik selle kasutaja aktiivsed seansid lõpetatakse otsekohe.',
    revokeIncludeTokens: 'Tühista ka rakenduste tokenid',
    revokeConfirm: 'Tühista',

    // Standarddialoog (voor #156): täielikud üksikasjad, sakid konto ja
    // turvalisus.
    tabAccount: 'Konto',
    tabSecurity: 'Turvalisus',
    usernameImmutableHint: 'Kasutajanimi on konto identiteet — fikseeritud loomisel',
    groups: 'Grupid',
    noGroups: 'Ühtegi gruppi ei ole',
    mustChangePassword: 'Parooli vahetus on kohustuslik',
    failedAttempts: 'Nurjunud sisselogimiskatsed',
    lockedUntil: 'Lukustatud kuni',

    // Identiteedi sakid (2026-08-03): Süsteem > Kasutajad on muutunud
    // sakkidega jaotiseks /system/rbac eeskujul — kasutajad, grupid, välised
    // realmid.
    tabUsers: 'Kasutajad',
    tabGroups: 'Grupid',
    tabRealms: 'Realmid ja SSO',
    tabMfa: 'MFA',

    // MFA sakk (task #178, pool A — GUI olemasoleva contracti peal): teise
    // faktori kasutajapõhine vaade. Väliste identiteetide seadistused ja
    // orvuolek on pool B — contracti voor, mitte kunagi vormi ilma
    // backendita.
    mfa: {
      title: 'Teine faktor (MFA)',
      methodsTitle: 'Saadaolevad meetodid',
      methodsSubtitle: 'See, mida see paigaldus oskab teise faktorina kontrollida',
      methodsError: 'Meetodite registri laadimine ebaõnnestus',
      builtinChip: 'Sisseehitatud',
      enrollableChip: 'Seadistatav TVirtis',
      delegatedChip: 'Hallatakse väljaspool',
      state: 'Olek',
      stateActive: 'Aktiivne',
      statePending: 'Ootab seadistamist',
      stateNone: 'Pole seadistatud',
      required: 'MFA kohustus',
      requiredChip: 'Kohustuslik',
      notRequiredChip: 'Pole kohustuslik',
      enrolledAt: 'Seadistatud',
      enrolledMethods: 'Seadistatud meetodid',
      noMethods: 'Ühtegi seadistust ei ole',
      codesRemaining: 'Taastekoode alles',
      resetTitle: 'Lähtesta teine faktor',
      resetHint:
        'Seadistus ja kõik taastekoodid nullitakse: järgmisel sisselogimisel teeb kasutaja seadistuse otsast peale. MFA kohustus jääb selliseks, nagu on — administraator ei määra kunagi saladust, ta ainult nullib selle.',
      resetConfirm: 'Lähtesta',
      resetError: 'Teise faktori lähtestamine ebaõnnestus',
      empty: 'Ühtegi hallatavat kasutajat veel ei ole — kontod ilmuvad siia kohe, kui nad olemas on, igaüks koos oma teise faktori olekuga.',

      // Pool B (voor #178): kehtiva verdikti päritolu, välised seadistused
      // orvu olekuga, kohustust nõudvad grupid.
      viaSelf: 'Isiklik',
      viaSelfHint: 'Konto enda panus (tema lipp) — ainus osa, mida pliiats muudab.',
      viaGroupHint: 'Sellest grupist päritud kohustus: isikliku lipu eemaldamine kasutajat ei vabasta — sekkuda tuleb grupis, sakil Grupid.',
      subject: 'Identiteet',
      lastSeenAt: 'Viimati kinnitatud',
      enrollmentPending: 'Ootel',
      orphanChip: 'Orb',
      orphanDirectoryMiss: 'Identiteeti ei ole enam kataloogis',
      orphanRealmRemoved: 'Realm eemaldati TVirtist',
      orphanedAt: 'Orb alates',
      directoryUuid: 'UUID kataloogis',
      externalTitle: 'Välised seadistused',
      externalEmpty: 'Veel ühtegi välist seadistust ei ole — see sünnib MFA kohustusega kataloogi-identiteedi esimesel sisselogimisel.',
      orphanHelp:
        'Orvuks jäänud seadistus ei kustu kunagi iseenesest: see on turvamaterjal — see jääb auditi jaoks alles, ja kui identiteet kataloogi naaseb, leiab ta oma faktori taas. Ainus väljapääs on administratiivne lähtestamine.',
      visibilityHint: 'Välised seadistused asuvad klastri juurtasemel: neid näeb ainult see, kellel on user.read üle kogu puu.',
      orphanResetHint:
        'Orvuks jäänud rida eemaldatakse lõplikult: keegi ei nõua seda enam. Kui identiteet kataloogi naaseb, teeb ta seadistuse otsast peale.',
      enforcingTitle: 'Grupid, mis nõuavad MFA-d',
      enforcingSubtitle:
        'Väliste identiteetide kohustuse ankur on grupp: tema realmi vastendused ütlevad, millise kataloogi populatsioonini see ulatub. Väline seadistus sünnib kohustusega kasutaja esimesel sisselogimisel.',
      enforcingEmpty: 'Ükski grupp MFA-d ei nõua — kohustus lülitatakse sisse grupil, sakilt Grupid.',
      enforcingError: 'MFA-d nõudvate gruppide laadimine ebaõnnestus'
    }
  },
  realms: {
    title: 'Autentimise realmid',
    createTitle: 'Loo realm',
    editTitle: 'Muuda realmi',
    name: 'Realm',
    nameHint: 'Domeen, mille kasutajad kirjutavad @-märgi järele (example.com) — pärast loomist muutumatu',
    nameImmutableHint: 'Realmi nimi on trükitud igasse seanssi ja igasse auditireasse, mis teda kunagi nimetanud on — ümbernimetamine kirjutaks ajaloo ümber',
    kind: 'Tüüp',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC ja SAML jõuavad kohale järgmiste voorudega — täna on realm LDAPv3 kataloog',

    // Loomise poolvisard (realm-wizardi voor, 2026-08-03): 1. sammu tüübikaardid
    // — ldap elus, oidc/saml roadmapi kaardid (mitte kunagi vormi, mille taga
    // backendit ei ole).
    kindCategory: 'Realmi tüüp',
    kindSelectHint: 'Vali kataloogi tüüp, mille vastu see realm autendib.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Kasutajanimi ja parool kontrollitakse LDAPv3 kataloogi vastu bindiga — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Brauseripõhine single sign-on, delegeeritud OpenID Connecti identiteedipakkujale — jõuab kohale järgmiste voorudega.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Ettevõtte single sign-on SAML 2.0 kinnitustega — jõuab kohale järgmiste voorudega.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Lubatud',
    urls: 'Kataloogiserverid',
    urlsHint: 'Üks ldap:// või ldaps:// URL rea kohta (1–8), proovitakse järjekorras — failover, mitte kunagi koormusjaotus',
    startTls: 'StartTLS',
    verifyCertificate: 'Kontrolli sertifikaati',
    cleartextWarning: 'Ilma ldaps:// või StartTLS-ita liigub bindi parool üle võrgu avatekstina — laboris talutav, tootmises mitte kunagi.',
    noVerifyWarning: 'Kontrollimata TLS-seanss ei autendi kedagi: lülita kontroll välja ainult sellise kataloogi puhul, mida sa korda teha ei saa.',
    caCertificate: 'CA sertifikaat (PEM)',
    caCertificateHint: "Valikuline CA kimp, mis on selle realmi TLS/StartTLS handshake'i jaoks kinnistatud; tühi eemaldab selle",
    caCertificatePinned: 'Kinnistatud',
    connectTimeout: 'Ajapiirang (sekundites)',
    connectTimeoutHint: 'URL-i kaupa kehtiv ühenduse ja päringu tähtaeg (1–60); tähtaja möödudes proovitakse järgmist URL-i',
    bindDn: 'Bind DN',
    bindDnHint: 'Teenusekonto, mis kasutaja otsingu teeb; tühi = anonüümne search bind (AD lükkab tagasi)',
    anonymousBind: 'Anonüümne search bind',
    bindCredential: 'Bindi parool (keystore)',
    bindCredentialHint: "Keystore'i usernamePassword-kirje bindi parooliga — saladus ei ela mitte kunagi realmis endas",
    bindCredentialNone: 'Puudub (anonüümne bind)',
    bindCredentialEmpty: "Keystore'is ei ole ühtegi usernamePassword-kirjet — loo bindi parooli jaoks üks Süsteem > Mandaadid all.",
    baseDn: 'Base DN',
    baseDnHint: 'Alampuu, kust kasutaja otsing algab (DC=example,DC=com)',
    userFilter: 'Kasutaja filter',
    userFilterHint: '%u asendatakse sisselogimisnime kohaliku osaga, RFC 4515 järgi eskeeritult; mitte-AD kataloogid tahavad tavaliselt (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atribuut memberOf',
    memberOfAttributeHint: 'Loetakse ainult üks kord, sisselogimisel — vastendamata grupid eiratakse, pesastust ei lahendata',
    uuidAttribute: 'Atribuut UUID',
    uuidAttributeHint: 'Realmis muutumatu UUID (AD-s objectGUID, OpenLDAP-is entryUUID) — trükitakse auditisse kasutaja@realm kõrvale',
    displayNameAttribute: 'Kuvatava nime atribuut',
    displayNameAttributeHint: 'Kasutatakse kasutaja tervitamiseks; selle puudumisel kasutatakse sisselogimisnime',
    sudoHint: 'Realmide kirjutused on sudo-kaitsega: realm on uks platvormi sisse',
    deleteBody: 'Realmi grupivastendused lahkuvad koos temaga; seansid, mille ta on autentinud, jäävad kuni aegumiseni elama — kustutatud realm lihtsalt ei lase enam kedagi sisse.',
    tabConnection: 'Ühendus',
    tabDirectory: 'Kataloog',
    testTitle: 'Testi ühendust',
    testHint: 'Konfiguratsiooni sond, mitte kunagi autentimine: ühendub, teeb teenusekontoga bindi ja — kui kasutajanimi on antud — käivitab kasutaja filtri.',
    testUsername: 'Kasutajanimi (valikuline)',
    testUsernameHint: 'Kohalik osa, mille peal kasutaja filtrit käivitada — 1 vaste on terve vastus',
    testRun: 'Käivita test',
    testError: 'Sondi käivitamine ebaõnnestus',
    testReachable: 'Kataloog on kättesaadav, teenuse bind võeti vastu',
    testUnreachable: 'Kataloog EI OLE kättesaadav',
    matchedOne: 'Kasutaja filter leidis täpselt 1 kirje — terve vastus.',
    matchedNone: 'Kasutaja filter ei leidnud ühtegi kirjet: filter või base DN on vale.',
    matchedMany: 'Kasutaja filter leidis {count} kirjet: see ei ole selektiivne ja sisselogimised jääksid mitmetimõistetavaks (lükataks tagasi).',
    mappingsPointer: 'See, millele väline grupp vastab, on TVirti grupi omadus (tema realmi vastendused): tõe koht elab sakil Grupid.',
    mappingsPointerLink: 'Ava sakk Grupid',
    rootHomeHint: 'Välise realmi identiteedid elavad klastri juures, mitte kunagi vDC-s: õigused antakse sinna, kus neid vaja on, delegeeringutega — grupile või otse kasutajale, täpselt nagu kohalikegi puhul.'
  },
  credentials: {
    title: 'Mandaadid',
    createTitle: 'Loo mandaat',
    editTitle: 'Muuda mandaati',
    kind: 'Tüüp',
    kindUsernamePassword: 'Kasutajanimi ja parool',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-i identiteet)',
    kindHintUsernamePassword: "Muutumatu. CIFS/SMB storage'ite jaoks — haakimiskonto, mille saladust worker haakimise hetkel kasutab.",
    kindHintIscsiChap: 'Muutumatu. iSCSI CHAP-autentimise jaoks — kasutajanimi = CHAP-nimi, saladus = CHAP-saladus.',
    kindHintNvmeDhchap: 'Muutumatu. NVMe over Fabricsi DH-HMAC-CHAP-i jaoks — saladus = blob DHHC-1:xx:…; kasutajanimi on ainult silt.',
    kindHintCephx: 'Muutumatu. Ceph-i klientide jaoks — kasutajanimi = kliendi nimi (client.…), saladus = base64-võti.',
    kindImmutableHint: 'Tüüp on pärast loomist muutumatu — selle muutmine tähendab uut mandaati.',
    username: 'Kasutajanimi',
    usernameChap: 'CHAP-nimi',
    usernameNvme: 'Silt',
    usernameCephx: 'Kliendi nimi',
    usernameHint: 'Valikuline konto, kellele saladus kuulub',
    usernameHintChap: 'CHAP-nimi, millega initsiaator end autendib',
    usernameHintNvme: 'Transport seda ei kasuta — vaba silt sinu enda märkmete jaoks',
    usernameHintCephx: 'cephx-kliendi nimi — prefiksit client. talutakse',
    secret: 'Saladus',
    secretHint: 'Ainult kirjutamiseks: tarbijad kasutavad seda, rohkem seda ei näidata.',
    secretHintNvmeDhchap: 'Ainult kirjutamiseks: DH-HMAC-CHAP hosti saladus kanoonilisel kujul DHHC-1:xx:… — tarbijad kasutavad seda, rohkem seda ei näidata.',
    secretHintCephx: 'Ainult kirjutamiseks: base64-kujul cephx-võti — tarbijad kasutavad seda, rohkem seda ei näidata.',
    secretEditHint: 'Jäta tühjaks, et saladust mitte muuta — selle täitmine rotreerib saladuse.',
    createdAt: 'Loodud',
    inUseError: "'{name}' on viidatud mõne storage'i konfiguratsioonis — haagi ta kõigepealt seal lahti.",
    nameHint: "Väiketähed, numbrid ja sidekriipsud (DNS-1123); unikaalne scope'i kohta",

    // Ainult rotatsiooni dialoog (voor #156): saladusel ei ole kunagi inline-pliiatsit.
    rotateTitle: 'Rotreeri saladus',
    rotateHint: 'Ainult kirjutamiseks: uus saladus asendab salvestatu — tarbijad võtavad selle kasutusele järgmisel haakimisel.',

    // Voor #159 (PKI): sakid Sertifikaadid ja CA-d.
    tabSecrets: 'Saladused',
    tabCertificates: 'Sertifikaadid',
    tabAuthorities: 'Sertifitseerimiskeskused',
    certificatesTitle: 'Sertifikaadid',
    authoritiesTitle: 'Sertifitseerimiskeskused',
    caCreateTitle: 'Uus CA',
    certCreateTitle: 'Uus sertifikaat',
    caMode: 'Päritolu',
    caModeGenerate: 'Genereeri TVirtiga',
    caModeImport: 'Impordi (võti + sertifikaat)',
    certMode: 'Päritolu',
    certModeIssue: "Väljasta keystore'i CA-ga",
    certModeImport: 'Impordi (võti + sertifikaat)',
    issuingCa: 'Väljastav CA',
    issuingCaHint: "Sertifikaat sünnib CA scope'is, registreeritud ülemaga",
    noCasHint: "Keystore'is ei ole ühtegi CA-d — genereeri või impordi kõigepealt üks CA sakil",
    commonName: 'Common name (CN)',
    commonNameCaHint: 'CA subjekt: tähed, numbrid, tühik, punkt, alakriips, sidekriips',
    commonNameCertHint: 'OpenVPN tuvastab kliente CN-i järgi — hoia see CA piires unikaalne',
    days: 'Kehtivus (päevades)',
    daysCaHint: '1–7300 päeva; vaikimisi 3650 (10 aastat)',
    daysCertHint: '1–3650 päeva; vaikimisi 365',
    keyType: 'Võtme tüüp',
    keyTypeHint: 'Vaikimisi EC P-256; RSA vanade tarbijate jaoks',
    usage: 'Kasutus',
    usageClient: 'Klient (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Extended key usage, mille jaoks sertifikaat väljastatakse',
    san: 'Alternatiivsed nimed (SAN)',
    sanHint: 'Komadega eraldatud; literaalsed IP-d muutuvad IP:-kirjeteks, ülejäänud DNS:-kirjeteks',
    keyPem: 'Privaatvõti (PEM)',
    keyPemHint: "Ainult kirjutamiseks: hoitakse keystore'is, rohkem seda ei näidata",
    certPem: 'Sertifikaat (PEM)',
    certPemHint: 'Avalik sertifikaat, mis võtmega paari läheb',
    certPemCaHint: 'CA sertifikaat, mis võtmega paari läheb (basicConstraints CA)',
    subject: 'Subjekt',
    issuer: 'Väljastaja',
    parentCa: 'Väljastav CA',
    parentCaImported: 'Imporditud — väljastatud väljaspool TVirti',
    serial: 'Seerianumber',
    fingerprint: 'Sõrmejälg (SHA-256)',
    validFrom: 'Kehtiv alates',
    validUntil: 'Kehtiv kuni',
    expiry: 'Aegumine',
    expired: 'Aegunud',
    expiresInDays: 'Aegub {days} p pärast',
    revoked: 'Tühistatud',
    revokedAtLabel: 'Tühistatud',
    revokeTitle: 'Tühista sertifikaat',
    revokeAction: 'Tühista',
    revokeWarning: 'Tühistamine on lõplik: seerianumber läheb väljastava CA CRL-i ja iga tarbija, kes tühistatud sertifikaate ei aktsepteeri (eeskätt OpenVPN), lükkab selle tagasi. Tühistamist tagasi võtta ei saa.',
    exportPem: 'Ekspordi PEM',
    exportChain: 'Ekspordi ahela kimp',
    exportCrl: 'Ekspordi CRL',
    materialImmutableHint: 'X.509 materjal on muutumatu — väljasta või impordi uuesti',
    caInUseError: "'{name}' juures on veel elus väljastatud sertifikaate (või viitab talle mõni storage) — tühista või kustuta need enne."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Paigutus, käideldavus ja afiinsus — kus klastri VM-id töötavad ja kas nad peavad olema käivitatud',
    loadError: "Proximity paneel vajab klastri store'i — pargi olek ei ole praegu kättesaadav",
    config: {
      title: 'Konfiguratsioon',
      subtitle: 'Klastri tasandi paigutuspoliitika',
      save: 'Salvesta',
      saveError: 'Konfiguratsioon lükati tagasi',
      strategy: 'Valikustrateegia',
      strategy_leastUsedResources: 'Kõige vähem kasutatud ressursid',
      strategy_leastVms: 'Kõige vähem VM-e',
      strategy_random: 'Juhuslik',
      strategyLeastUsedResourcesHint: 'Kehtivate kandidaatide seast sõlm, kellel on kõige rohkem kasutatavat RAM-i alles (vaadeldud kogumaht − hosti reserv − töötavad VM-id), viigi murrab vCPU kohustus. Samade andmete korral deterministlik.',
      strategyLeastVmsHint: 'Kehtivate kandidaatide seast sõlm, kellel on kõige vähem töötavaid VM-e; viigid lahendatakse nime järgi. Samade andmete korral deterministlik.',
      strategyRandomHint: 'Ühtlaselt juhuslik kehtivate kandidaatide seast.',
      liveness: 'Sõlmede elususe lävi (sekundites)',
      livenessHint: 'Liige, kes vaikib üle läve, on kättesaamatu: ta jäetakse paigutusest välja ja — kui ta ei ole hoolduses — loeb HA otsustaja ta surnuks, tarastab ta ja käivitab tema HA VM-id mujal uuesti.',
      decider: 'HA otsustaja',
      deciderNone: 'veel valimata'
    },
    nodesTitle: 'Sõlmed',
    nodesSubtitle: 'Elusus ja empiiriline maht — kasutatav RAM = kokku − baas − seotud',
    nodeCol: 'Sõlm',
    stateCol: 'Olek',
    ramCol: 'RAM (kokku − baas − seotud)',
    usableCol: 'Kasutatav',
    vmsCol: 'Koormus',
    neverSeen: 'pole kunagi nähtud',
    freshChip: 'kättesaadav',
    staleChip: 'kättesaamatu',
    attestedChip: 'atesteeritud seiskunuks',
    ramFormula: 'kokku − baas − seotud',
    haTitle: 'Kõrgkäideldavus',
    haSubtitle: 'HA lipuga VM-id on "alati sees": TVirt käivitab nad pärast iga soovimatut seiskumist uuesti — samas sõlmes backoffiga, teises sõlmes siis, kui nende oma sureb (ainult jagatud storage).',
    haNone: 'Ühelgi VM-il ei ole veel HA lippu — luba see siin või VM-i üksikasjades.',
    haVmCol: 'Virtuaalmasin',
    haStateCol: 'Olek',
    haRestartsCol: 'HA taaskäivitused',
    haLastEventCol: 'Viimane sündmus',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA muutmine lükati tagasi',
    rules: {
      title: 'Afiinsusreeglid',
      createTitle: 'Uus Proximity reegel',
      editTitle: 'Muuda reeglit',
      nameHint: 'Väiketähed, numbrid ja sidekriipsud (DNS-silt)',
      vms: 'Virtuaalmasinad',
      vmsHint: 'Vähemalt kaks VM-i — reegel piirab, kus nad üksteise suhtes töötavad',
      type: 'Tüüp',
      affinity: 'Afiinsus (koos)',
      antiAffinity: 'Antiafiinsus (eraldi)',
      typeAffinityHint: 'VM-id peavad töötama SAMAS sõlmes.',
      typeAntiAffinityHint: 'VM-id peavad töötama ERI sõlmedes — klassikaline HA paar.',
      mode: 'Režiim',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Rikkumised lükkavad toimingu (käivitus, migratsioon, failover) tagasi kõneka veateatega.',
      modeSoftHint: 'Eelistus, mitte kunagi blokeeriv: rikkumisega paigutus läheb läbi koos nähtava hoiatusega.',
      satisfied: 'Paigutus',
      satisfiedYes: 'järgitud',
      satisfiedNo: 'rikutud',

      // Standarddialoog (voor #156): rikkumistel on oma rida, mitte tooltip.
      violations: 'Rikkumised',
      noViolations: 'Ühtegi'
    },
    events: {
      title: 'HA sündmused',
      subtitle: "Käideldavuse päevik — taaskäivitused, tarastamised, failover'id ja ausad vahelejätmised",
      none: 'Veel mitte midagi.',
      when: 'Millal',
      kind: 'Sündmus',
      target: 'Objekt',
      detail: 'Üksikasjad',
      kindRestarted: 'HA taaskäivitus',
      kindGaveUp: 'alla antud (crash loop)',
      kindNodeAttested: 'sõlm tarastatud',
      kindFailedOver: 'failover',
      kindNoCandidate: 'kandidaati ei ole',
      kindStorageLocalSkip: 'vahele jäetud (kohalik storage)',
      kindZombieFenced: 'zombie lõpetatud'
    }
  }
}
